<template>
  <div>
    <mdb-modal size="lg" :show="visible" @shown="componentDidMount" @close="hideModal">
      <mdb-modal-header>
        <mdb-modal-title>{{this.merchant?this.merchant.name:""}}</mdb-modal-title>
      </mdb-modal-header>
      <mdb-modal-body>
            <mdb-row v-if="loading">
                <mdb-col col="12" class="d-flex flex-center">
                    <mdb-spinner />
                </mdb-col>
            </mdb-row>
            <mdb-container v-if="this.merchant">
                <mdb-row class="mb-3">
                    <mdb-col>
                        <mdb-card>
                            <mdb-card-body>
                                <div class="d-flex flex-center" style="width: 100%; height: 220px">
                                    <mdb-view :src="getAvatar(this.merchant.avatar)" alt="image" style="height: 200px; width: 400px;">
                                        <a @click="openFileSelect">
                                            <mdb-mask overlay="white-slight"></mdb-mask>
                                        </a>
                                        <input multiple type="file" id="file-upload" @change="avatarUpload" hidden />
                                    </mdb-view>
                                </div>
                                <span class="text-danger">720*360</span>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>
                <mdb-row class="mb-3">
                    <mdb-col>
                        <mdb-card>
                            <mdb-card-body>
                            <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Auth Information</h4>
                                <mdb-row>
                                    <mdb-col md="6">
                                        <mdb-input v-if="!checkPermissions(47)" :disabled="username_disabled" label="Username" v-model="merchant.user.username" size="sm" />
                                        <div v-if="checkPermissions(47)" class="d-flex flex-row align-items-center">
                                            <mdb-input :disabled="username_disabled" label="Username" v-model="merchant.user.username" size="sm" />
                                            <div>
                                                <mdb-btn v-if="username_disabled" @click="enableUsernameEdit" color="primary" size="sm"><mdb-icon far icon="edit" /></mdb-btn>
                                                <mdb-btn v-if="!username_disabled" @click="showUsernameConfirmationModal" color="success" size="sm"><mdb-icon icon="check" /></mdb-btn>
                                            </div>
                                        </div>
                                    </mdb-col>
                                    <mdb-col md="6">
                                        <mdb-input disabled label="Last Login" v-model="merchant.user.last_login" size="sm" />
                                    </mdb-col>
                                </mdb-row>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>
                <mdb-row class="mb-3" v-if="checkPermissions(22)">
                    <mdb-col>
                        <mdb-card>
                            <mdb-card-body>
                                <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Profile Information</h4>
                                <mdb-row>
                                    <mdb-col md="6">
                                        <mdb-input label="Name *" v-model="merchant.name" size="sm" />
                                        <mdb-input label="Contact Number *" v-model="merchant.contact_number" size="sm" />
                                        <mdb-input label="Address *" v-model="merchant.address" size="sm" />
                                        <mdb-input v-model="merchant.company_registration_name" label="Company Registration Name / Owner Name *" size="sm" />
                                        <mdb-input v-model="merchant.delivery_fees" label="Delivery Fee *" size="sm" />
                                        <mdb-input label="Website" v-model="merchant.website" size="sm" />
                                    </mdb-col>
                                    <mdb-col md="6">
                                        <mdb-input label="Email *" v-model="merchant.email" size="sm" />
                                        <mdb-input label="Alt Contact Number" v-model="merchant.alt_contact_number" size="sm" />
                                        <mdb-input label="Description" v-model="merchant.description" size="sm" />
                                        <mdb-input v-model="merchant.company_registration_id" label="Company Registration ID / Ownder IC *" size="sm" />
                                        <mdb-input v-model="merchant.prepare_time" label="Prepare Time *" size="sm" />
                                    </mdb-col>
                                </mdb-row>
                            </mdb-card-body>
                            <mdb-card-footer class="d-flex justify-content-end" v-if="!action_loading && checkPermissions(74)">
                                <mdb-btn size="sm" color="primary" @click="updateMerchant('INFO')"><mdb-icon far icon="save" style="margin-right: 5px" />Profile Info</mdb-btn>
                            </mdb-card-footer>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>
                <mdb-row class="mb-3" v-if="checkPermissions(23)">
                    <mdb-col>
                        <mdb-card>
                            <mdb-card-body>
                                <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Financial Information</h4>
                                <mdb-row>
                                    <mdb-col md="6">
                                        <label style="font-size: 0.75rem; margin-bottom: 0px; color: #757575">Bank Name *</label>
                                        <select v-model="merchant.bank_name" class="custom-select custom-select">
                                            <option value="08-AmBank Berhad">08-AmBank Berhad</option>
                                            <option value="12-Alliance Bank Berhad">12-Alliance Bank Berhad</option>
                                            <option value="53-Al-Rajhi Banking and Investment Corporation (Malaysia) Berhad">53-Al-Rajhi Banking and Investment Corporation (Malaysia) Berhad</option>
                                            <option value="32-Affin Bank Berhad">32-Affin Bank Berhad</option>
                                            <option value="49-Agro Bank">49-Agro Bank</option>
                                            <option value="42-Bank of China (Malaysia) Berhad">42-Bank of China (Malaysia) Berhad</option>
                                            <option value="41-Bank Muamalat Malaysia Berhad">41-Bank Muamalat Malaysia Berhad</option>
                                            <option value="45-Bank Islam Malaysia Berhad">45-Bank Islam Malaysia Berhad</option>
                                            <option value="02-Bank Rakyat Berhad">02-Bank Rakyat Berhad</option>
                                            <option value="10-Bank Simpanan Nasional Berhad">10-Bank Simpanan Nasional Berhad</option>
                                            <option value="07-Bank of America">07-Bank of America</option>
                                            <option value="52-Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad">52-Bank of Tokyo-Mitsubishi UFJ (Malaysia) Berhad</option>
                                            <option value="60-BNP Paribas (M) Bhd / BNP Paribas (Islamic)">60-BNP Paribas (M) Bhd / BNP Paribas (Islamic)</option>
                                            <option value="35-CIMB Bank Berhad">35-CIMB Bank Berhad</option>
                                            <option value="17-Citibank">17-Citibank</option>
                                            <option value="19-Deutsche Bank (M) Bhd">19-Deutsche Bank (M) Bhd</option>
                                            <option value="24-Hong Leong Bank Berhad/ Hong Leong Finance">24-Hong Leong Bank Berhad/ Hong Leong Finance</option>
                                            <option value="22-HSBC Bank Berhad">22-HSBC Bank Berhad</option>
                                            <option value="59-Indust & Comm Bank of China (M) Berhad">59-Indust & Comm Bank of China (M) Berhad</option>
                                            <option value="48-JP Morgan Chase">48-JP Morgan Chase</option>
                                            <option value="47-Kuwait Finance House">47-Kuwait Finance House</option>
                                            <option value="27-Malayan Banking Berhad">27-Malayan Banking Berhad</option>
                                            <option value="73-Mizuho Bank (M) Berhad">73-Mizuho Bank (M) Berhad</option>
                                            <option value="29-OCBC Bank Berhad">29-OCBC Bank Berhad</option>
                                            <option value="33-Public Bank Berhad/ Public Finance Berhad">33-Public Bank Berhad/ Public Finance Berhad</option>
                                            <option value="18-RHB Bank Berhad">18-RHB Bank Berhad</option>
                                            <option value="14-Standard Chartered Bank Berhad">14-Standard Chartered Bank Berhad</option>
                                            <option value="51-Sumitomo Mitsui Banking Corporation (M) Bhd ">51-Sumitomo Mitsui Banking Corporation (M) Bhd </option>
                                            <option value="46-The Royal Bank of Scotland Bhd">46-The Royal Bank of Scotland Bhd</option>
                                            <option value="26-United Overseas Bank (M) Bhd">26-United Overseas Bank (M) Bhd</option>
                                            <option value="75-MBSB">75-MBSB</option>
                                            <option value="04-Bangkok Bank Berhad">04-Bangkok Bank Berhad</option>
                                            <option value="65-China Construction Bank (Malaysia) Berhad">65-China Construction Bank (Malaysia) Berhad</option>
                                        </select>
                                        <mdb-input v-model="merchant.registration_id" label="Registration ID  (without dash, all capital letter) *" size="sm" />
                                        <mdb-input type="number" v-model="merchant.commission" label="Commission" size="sm" />
                                    </mdb-col>
                                    <mdb-col md="6">
                                        <mdb-input v-model="merchant.bank_account_name" label="Bank Beneficial Name *" size="sm" />
                                        <mdb-input v-model="merchant.bank_account_number" label="Bank Account Number *" size="sm" />
                                        <mdb-input v-model="merchant.subsidy" label="Delivery Subsidy *" size="sm" />
                                    </mdb-col>
                                </mdb-row>
                            </mdb-card-body>
                            <mdb-card-footer class="d-flex justify-content-end" v-if="!action_loading && checkPermissions(75)">
                                <mdb-btn size="sm" color="primary" @click="updateMerchant('FINANCE')"><mdb-icon far icon="save" style="margin-right: 5px" />Finance Info</mdb-btn>
                            </mdb-card-footer>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>
                <mdb-row class="mb-3" v-if="checkPermissions(24)">
                    <mdb-col>
                        <mdb-card>
                            <mdb-card-body>
                                <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Contact Information</h4>
                                <mdb-row>
                                    <mdb-col md="6">
                                        <mdb-input v-model="merchant.owner_name" label="Owner Name *" size="sm" />
                                        <mdb-input v-model="merchant.owner_ic" label="Owner IC *" size="sm" />
                                        <mdb-input v-model="merchant.pic_name" label="PIC Name *" size="sm" />
                                        <mdb-input v-model="merchant.pic_ic" label="PIC IC *" size="sm" />
                                        <mdb-input v-model="merchant.financial_name" label="Finance Name *" size="sm" />
                                        <mdb-input v-model="merchant.financial_ic" label="Finance IC *" size="sm" />
                                    </mdb-col>
                                    <mdb-col md="6">
                                        <mdb-input v-model="merchant.owner_mobile" label="Owner Mobile *" size="sm" />
                                        <mdb-input v-model="merchant.owner_email" label="Owner Email *" size="sm" />
                                        <mdb-input v-model="merchant.pic_mobile" label="PIC Mobile *" size="sm" />
                                        <mdb-input v-model="merchant.pic_email" label="PIC Email *" size="sm" />
                                        <mdb-input v-model="merchant.financial_mobile" label="Finance Mobile *" size="sm" />
                                        <mdb-input v-model="merchant.financial_email" label="Finance Email *" size="sm" />
                                    </mdb-col>
                                </mdb-row>
                            </mdb-card-body>
                            <mdb-card-footer class="d-flex justify-content-end" v-if="!action_loading && checkPermissions(76)">
                                <mdb-btn size="sm" color="primary" @click="updateMerchant('CONTACT')"><mdb-icon far icon="save" style="margin-right: 5px" />Contact Info</mdb-btn>
                            </mdb-card-footer>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>
                <mdb-row class="mb-3" v-if="checkPermissions(25)">
                    <mdb-col>
                        <mdb-card>
                            <mdb-card-body>
                                <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Extra Information</h4>
                                <mdb-row>
                                    <mdb-col md="4">
                                        <div class="d-flex flex-column">
                                            <label style="font-size: 0.75rem; margin-bottom: 0px; color: #757575">Halal Cert *</label>
                                            <select v-model="merchant.is_halal_cert" class="custom-select custom-select">
                                                <option value="0">No</option>
                                                <option value="1">Yes</option>
                                            </select>
                                        </div>
                                    </mdb-col>
                                     <mdb-col md="4">
                                        <div class="d-flex flex-column">
                                            <label style="font-size: 0.75rem; margin-bottom: 0px; color: #757575">PB Merchant *</label>
                                            <select v-model="merchant.is_pb" class="custom-select custom-select">
                                                <option value="0">No</option>
                                                <option value="1">Yes</option>
                                            </select>
                                        </div>
                                    </mdb-col>
                                    <mdb-col md="4">
                                        <div class="d-flex flex-column">
                                            <label style="font-size: 0.75rem; margin-bottom: 0px; color: #757575">Mart Merchant *</label>
                                            <select v-model="merchant.is_mart" class="custom-select custom-select">
                                                <option value="0">No</option>
                                                <option value="1">Yes</option>
                                            </select>
                                        </div>
                                    </mdb-col>
                                </mdb-row>
                            </mdb-card-body>
                            <mdb-card-footer class="d-flex justify-content-end" v-if="!action_loading && checkPermissions(77)">
                                <mdb-btn size="sm" color="primary" @click="updateMerchant('EXTRA')"><mdb-icon far icon="save" style="margin-right: 5px" />Extra Info</mdb-btn>
                            </mdb-card-footer>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>
                <mdb-row class="mb-3">
                    <mdb-col md="12">
                        <mdb-card>
                            <mdb-card-body>
                                <h4 class="h4-responsive" :style="{color: getColor('APP_1')}">Remarks</h4>
                                <div v-html="merchant.admin_remark" style="white-space: pre-wrap;"><br/></div>
                                <mdb-input outline type="textarea" v-model="admin_remark" :rows="2" />
                                <mdb-btn color="success" size="sm" @click="updateRemarks">Update Remarks</mdb-btn>
                            </mdb-card-body>
                        </mdb-card>
                    </mdb-col>
                </mdb-row>
            </mdb-container>    
      </mdb-modal-body>
      <mdb-modal-footer>
        <mdb-spinner v-if="action_loading" class="p-0 m-0" small color="blue"/>
        <mdb-btn color="danger" v-if="!action_loading && checkPermissions(27)" @click="resetPassword">Reset Password</mdb-btn>
        <mdb-btn color="danger" v-if="!action_loading && checkPermissions(28)" @click="resetPin">Reset Pin</mdb-btn>
        <mdb-btn color="secondary" v-if="!action_loading" @click.native="hideModal">Close</mdb-btn>
      </mdb-modal-footer>
    </mdb-modal>
    <ConfirmationModal :visible="confirmation_modal" :title="action_type=='PASSWORD'?'Reset Password?':'Reset Pin?'" :close="closeModal" :submit="actionReset" />
    <ConfirmationModal :visible="username_confirmation_modal" title="Confirm changing username? Action is not reversible" :close="closeModal" :submit="submitUsername" />
  </div>
</template>

<script>
  import { mdbModal, mdbModalHeader, mdbModalTitle, mdbModalBody, mdbModalFooter, mdbBtn, mdbCard, mdbCardBody, mdbRow, mdbCol,
  mdbContainer, mdbView, mdbMask, mdbInput, mdbSpinner, mdbIcon, mdbCardFooter } from 'mdbvue';
  import {APP_FILE_URL} from '../js/config';
  import {ajax, fileUploadAjax} from '../js/ajax';
  import {getColor} from '../js/colors';
  import {checkPermissionsBinary} from '../js/helper';
  import ConfirmationModal from '../components/ConfirmationModal';
  import {validateSpecialCharacter, validateNumber, validateRequired, validatePhone, validatePercentage} from '../js/validation';

  export default {
    components: {
      mdbModal,
      mdbModalHeader, mdbSpinner,
      mdbModalTitle, mdbInput,
      mdbModalBody, mdbView, mdbMask, ConfirmationModal,
      mdbModalFooter, mdbContainer, mdbIcon, mdbCardFooter,
      mdbBtn, mdbCard, mdbCardBody, mdbRow, mdbCol
    },
    props: ['visible', 'close', 'focus_merchant'],
    data: ()=>({
        action_loading: false,
        merchant: null,
        loading:true,
        action_type: "",
        confirmation_modal:false,
        username_disabled: true,
        username_confirmation_modal: false,
        admin_remark: ""
    }),
    methods: {
        componentDidMount(){
            this.merchant=this.focus_merchant;  
            this.loading=false;
            this.username_disabled=true;
        },
        hideModal(){
            this.loading=true;
            this.merchant=null;
            this.action_loading=false;
            this.close();
        },
        getAvatar(avatar){
            if(!avatar){
                return require('@/assets/placeholder_empty.jpg');
            }
            return APP_FILE_URL+avatar;
        },
        updateGeolocation(){
            this.merchant.lat=this.map.getCenter().lat();
            this.merchant.lng=this.map.getCenter().lng();
            this.$notify.success({message: 'Geolocation set. Please click update profile.', position:'top right', timeOut: 5000});
        },
        updateMerchant(type){
            var url = "admin/update_merchant_profile";
            switch(type){
                case "INFO":{
                    url="admin/update_merchant_profile_info";
                    if(!validateRequired(this.merchant.name)){
                        this.$notify.error({message: 'Merchant Name cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.email)){
                        this.$notify.error({message: 'Email cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validatePhone(this.merchant.contact_number)){
                        this.$notify.error({message: 'Invalid Contact Number', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.address)){
                        this.$notify.error({message: 'Address cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.company_registration_name)){
                        this.$notify.error({message: 'Company Registration Name cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.company_registration_id)){
                        this.$notify.error({message: 'Company Registration ID cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateNumber(this.merchant.delivery_fees)){
                        this.$notify.error({message: 'Invalid Delivery Fee', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateNumber(this.merchant.prepare_time)){
                        this.$notify.error({message: 'Invalid Merchant Prepare Time', position:'top right', timeOut: 5000});
                        return false;
                    }
                    break;
                }
                case "FINANCE":{
                    if(!validateRequired(this.merchant.bank_name)){
                        this.$notify.error({message: 'Bank Name cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.bank_account_name)){
                        this.$notify.error({message: 'Bank Account Name cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.bank_account_number)){
                        this.$notify.error({message: 'Bank Account Number cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.registration_id)){
                        this.$notify.error({message: 'Registration ID cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(validateSpecialCharacter(this.merchant.registration_id)){
                        this.$notify.error({message: 'Registration ID cannot consists Special Characters', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateNumber(this.merchant.subsidy)){
                        this.$notify.error({message: 'Invalid Subsidy Amount', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validatePercentage(this.merchant.commission)){
                        this.$notify.error({message: 'Invalid Commission', position:'top right', timeOut: 5000});
                        return false;
                    }
                    url="admin/update_merchant_finance_info";
                    break;
                }
                case "CONTACT":{
                    if(!validateRequired(this.merchant.owner_name) && !validateRequired(this.merchant.owner_ic) &&
                    !validateRequired(this.merchant.owner_mobile) && !validateRequired(this.merchant.owner_email)){
                        this.$notify.error({message: 'Owner Information cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.financial_name) && !validateRequired(this.merchant.financial_ic) &&
                    !validateRequired(this.merchant.financial_mobile) && !validateRequired(this.merchant.financial_email)){
                        this.$notify.error({message: 'Financial Information cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    if(!validateRequired(this.merchant.pic_name) && !validateRequired(this.merchant.pic_ic) &&
                    !validateRequired(this.merchant.pic_mobile) && !validateRequired(this.merchant.pic_email)){
                        this.$notify.error({message: 'PIC information cannot be empty', position:'top right', timeOut: 5000});
                        return false;
                    }
                    url="admin/update_merchant_contact_info";
                    break;
                }
                case "EXTRA":{
                    url="admin/update_merchant_extra_info";
                    break;
                }
            }
            if(this.action_loading){
                return false;
            }
            this.action_loading=true;
            ajax({
                url: url,
                data: {...this.merchant},
                complete: ()=>this.action_loading=false,
                success: ()=>{
                    this.$notify.success({message: this.merchant.name+' has been updated.', position:'top right', timeOut: 5000});
                },
            }, this)
        },
        avatarUpload(event){
            fileUploadAjax({
                url: "admin/update_merchant_avatar",
                data: {event: event.target.files, id: this.merchant.id},
                complete: ()=>this.action_loading=false,
                success: result=>{
                    this.$notify.success({message: this.merchant.name+' profile image has been updated.', position:'top right', timeOut: 5000});
                    this.merchant.avatar=result.data.avatar;
                },
                isShowAlert: true
            }, this)
        },
        openFileSelect(){
            if(!this.checkPermissions(22)){
                this.$notify.error({message: 'Access Denied.', position:'top right', timeOut: 5000});
                return false;
            }
            document.getElementById("file-upload").click();
        },
        getColor(text){
            return getColor(text);
        },
        checkPermissions(permission){
            return checkPermissionsBinary(permission, this.$store.state.permissions);
        },
        resetPassword(){
            this.confirmation_modal=true;
            this.action_type="PASSWORD";
        },
        resetPin(){
            this.confirmation_modal=true;
            this.action_type="PIN";
        },
        closeModal(){
            this.username_confirmation_modal=false;
            this.confirmation_modal=false;
        },
        actionReset(){
            if(this.action_loading){
                return false;
            }
            this.action_loading=true;
            ajax({
                url: this.action_type=="PASSWORD"?"admin/reset_merchant_password":"admin/reset_merchant_pin",
                data: {id: this.action_type=="PASSWORD"?this.focus_merchant.user.id:this.focus_merchant.id},
                complete: ()=>this.action_loading=false,
                success: result=>{
                    this.action_type=="PASSWORD"?
                    this.$notify.success({message: this.merchant.name+' password changed to '+result.data, position:'top right', timeOut: 5000}):
                    this.$notify.success({message: this.merchant.name+' pin changed to '+result.data, position:'top right', timeOut: 5000})
                },
            }, this)
        },
        enableUsernameEdit(){
            this.username_disabled=false;
        },
        showUsernameConfirmationModal(){
            this.username_confirmation_modal=true;
        },
        submitUsername(){
            ajax({
                url: "admin/submit_username_change",
                data: {user_id: this.merchant.user.id, username: this.merchant.user.username},
                complete: ()=>this.action_loading=false,
                success: ()=>{
                    this.$notify.success({message: 'Username had been changed', position:'top right', timeOut: 5000});
                    this.username_disabled=true;
                },
                isShowAlert: true,
            }, this)
        },
        updateRemarks(){
            ajax({
                url: "admin/submit_merchant_remark",
                data: {
                    id:this.merchant.id,
                    admin_remark: this.admin_remark
                },
                success: result=>{
                    if(this.merchant.admin_remark){
                        this.merchant.admin_remark=this.merchant.admin_remark+'<br/>'+this.admin_remark;
                    }else{
                        this.merchant.admin_remark=this.admin_remark;
                    }
                    this.admin_remark="";
                    this.merchant.admin_remark=result.data;
                    this.$notify.success({message: "Remarks Updated", position: 'top right', timeOut: 5000});
                }
            }, this)
        }
    }
  };
</script>